<template> 
     <div class="con_content" >
         <div class="container" >
            <div class="container_top h_48">商品管理</div>
            <div class="marginTB16" >
                <Button type="primary" @click="addGoods">发布商品</Button>
            </div>
            
            <div class="operating">
                <div style="width:100px">商品名称：</div>
                <Input   v-model="searchkey" style="width:200px"  placeholder="输入商品名称"  />

                <Button type="primary" style="margin:0 20px" @click="search">搜索</Button>
                <Button @click="getGoodsList">取消</Button>
            </div>

            <div>
                <Tabs type="card" v-model="card" @on-click="tabsClick">
                    <TabPane label="全部"   name="0"></TabPane>
                    <TabPane label="销售中" name="1"></TabPane>
                    <TabPane label="已售罄" name="2"></TabPane>
                    <TabPane label="仓库中" name="3"></TabPane>
                </Tabs>
                <div class="tabs-nav">
                    <Checkbox v-model="allSelectStatus" @on-change="checkSelect"><span style="marginLeft:10px">当前页面全选</span></Checkbox>
                    <Button v-if="card==0||card==3" style="marginLeft:10px" @click="shelves(0)">上架</Button>
                    <Button v-if="card!=3" style="marginLeft:10px" @click="shelves(1)">下架</Button>
                    <Button style="marginLeft:10px" @click="delGoods">删除</Button>
                    <Button style="marginLeft:10px" @click="showChangeGroupModal">改分组</Button>
                </div>
                <Table border ref="selection" @on-selection-change="selectCallback" :columns="columns" :data="goodsList" :loading="tableLoading">
                    <template slot-scope="{ row }" slot="name">
                        <div class="table-name" @click="toEdit(row)">
                            <img :src="row.image[0]" alt="" class="goods-image" />
                            <span>{{row.name}}</span> 
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="price">
                        <span>{{(row.price/100).toFixed(2)}}</span>
                    </template>
                    <template slot-scope="{ row }" slot="action">
                        <Button type="text"  @click="toEdit(row)">编辑</Button>
                    </template>
                </Table>
                 <Page class="pagination" :total="total" :page-size='size' @on-change="pageChange" show-total show-elevator />

                 <!-- 选择分组弹框 -->
                   <Modal
                   
                        v-model="groupModalVisible"
                        title="修改分组"
                        @on-ok="chanegGoodsGroupOk"
                        @on-cancel="$Message.success('已取消')"
                        >
                        <Form :style="{'height':goodsGroup.length*35+'px'}">
                            <FormItem label="* 商品分组：">
                                <Select  style="width:200px"   :max-tag-count="1" v-model="goodGroupGuid">
                                    <Option v-for="item in goodsGroup" :value="item.guid" :key="item.guid">{{ item.name }}</Option>
                                </Select>
                            </FormItem>
                        </Form>
                    </Modal>
            </div>
         </div>
         
     </div>
</template> 
<script>
import axios from 'axios'
    export default {
        name:'manage',
        data () {
            return { 
                card: '0',
                page:0,//页码
                size:10,//默认每页条数
                searchkey:'',//搜索关键词
                tableLoading:false,
                allSelectStatus:false,//多选框
                total:0,//总共条数
                columns: [
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: '商品名字',
                        width: 300,
                        slot: 'name',
                    },
                    {
                        title: '价格(元)',
                        slot: 'price',
                        sortable: true
                    },
                    {
                        title: '孝心值',
                        key:'integral',
                        sortable: true
                    },
                    {
                        title: '浏览量',
                        key: 'pageview',
                    },
                    {
                        title: '库存',
                        key: 'stock',
                        sortable: true
                    },
                    {
                        title: '销量',
                        key: 'salesVolume',
                        sortable: true
                    },
                    {
                        title: '创建时间',
                        key: 'createTime',
                        sortable: true
                    },
                    {
                        title: '商品状态',
                        key: 'stateName',
                    },
                    {
                        title: '操作',
                        slot: 'action',
                    }
                ],
                goodsList: [],
                selectList:[],//选中商品
                groupModalVisible:false,//显示商品分组弹框
                goodsGroup:'',//商品全部分组
                goodGroupGuid:'',//选择的商品分组的GUID
             
            }
        },
        created(){
          
        },
        methods: {
            //获取商品数据
            getGoodsList(){
                this.tableLoading = true
                const url = `https://api.jiapuji.vip/gateway/admin/service/mail/commodity/get?type=${this.card}&page=${this.page}&size=${this.size}`
                axios({url:url}).then(res=>{
                    if(res.status==200 && res.data.code==1){
                        this.tableLoading = false
                        this.goodsList = res.data.data.list
                        this.total = res.data.data.total
                        console.log(res.data.data.list[0].commodityCode==null)
                    }else{
                        this.$Message.error({
                            background: true,
                            content: '加载失败，亲稍后再试'
                        });
                    }
                })
            },
            //获取商品品类
            getGoodsCategory(){
                axios({
                    url:'https://api.jiapuji.vip/gateway/admin/service/mail/category/get'
                }).then(res=>{
                    if(res.status == 200 && res.data.code==1){
                        this.goodsCategory = res.data.data
                    }else{
                        this.$Message.error('网络异常');
                    }
                })
            },
            //获取商品分类
            getGoodsGroup(){
                axios({
                    url:'https://api.jiapuji.vip/gateway/admin/service/mail/commodity/group/get'
                }).then(res=>{
                    if(res.status == 200 && res.data.code==1){
                        this.goodsGroup = res.data.data
                    }else{
                        this.$Message.error('网络异常');
                    }
                })
            },
            tabsClick(){
                this.page = 0
                this.getGoodsList()
            },
            //全选Btn
            checkSelect(){
                 this.$refs.selection.selectAll(this.allSelectStatus)
            },
            //选择商品时的回调函数
            selectCallback(e){
                this.selectList = e
            },
            //上架商品
            shelves(type){
                if(this.selectList.length !=0){
                    let list =[]
                    this.selectList.forEach(item=>{
                        list.push(item.guid)
                    })
                    axios({
                        url:'https://api.jiapuji.vip/gateway/admin/service/mail/commodity/sell/?route=layout/goods/manage/sell',
                        method:'PUT',
                        data:{list,type}
                    }).then(res=>{
                        if(res.status==200 && res.data.code==1){
                          this.$Message.success('操作成功')
                          this.selectList=[]
                          this.$refs.selection.selectAll(false);
                          this.getGoodsList()
                        }else{
                            this.$Message.error('操作成功,请稍后再试');
                        }
                    })
                }else{
                    this.$Message.error('请先选择')
                }
            },
            //删除商品
            delGoods(){
                if(this.selectList.length !=0){
                    let list =[]
                    this.selectList.forEach(item=>{
                        list.push(item.guid)
                    })
                     this.$Modal.confirm({
                            title: '警告',
                            content: '是否删除当前选中商品，删除后不可恢复！',
                            onOk:()=>{
                                axios({
                                    url:'https://api.jiapuji.vip/gateway/admin/service/mail/commodity/delete/?route=/layout/goods/manage/delete',
                                    method:'PUT',
                                    data:list
                                }).then(res=>{
                                    if(res.status==200 && res.data.code==1){
                                    this.$Message.success('删除成功');
                                    this.selectList=[]
                                    this.$refs.selection.selectAll(false);
                                    this.getGoodsList()
                                    }else{
                                        this.$Message.error('删除失败,请稍后再试');
                                    }
                                })
                            },
                            onCancel:()=>{
                                this.$Message.success('已取消')
                            }
                        });
                    
                }else{
                    this.$Message.error('请先选择')
                }
            },
            //显示商品分组弹框
            showChangeGroupModal(){
               if(this.selectList.length !=0){
                    this.groupModalVisible = true
                }else{
                    this.$Message.error('请先选择')
                }
            },
            //修改商品分组弹框 确定
            chanegGoodsGroupOk(){
                if(this.goodGroup == ''){
                    this.$Message.error('请先选择分组');
                }else{
                    let list =[]
                    this.selectList.forEach(item=>{
                        list.push(item.guid)
                    })
                    axios({
                        url:'https://api.jiapuji.vip/gateway/admin/service/mail/commodity/group/list/update?route=layout/goods/manage/group/update',
                        method:'PUT',
                        data:{list,commodityGroupGuid:this.goodGroupGuid}
                    }).then(res=>{
                        if(res.status==200 && res.data.code==1){
                            this.$Message.success('修改成功');
                            this.selectList=[]
                            this.$refs.selection.selectAll(false);
                        }else{
                            this.$Message.error('修改失败,请稍后再试');
                        }
                    })
                }
            },
            //编辑按钮
            toEdit(row){
                this.$router.push({ path: '/layout/goods/manage_child', query:{guid:row.guid}})
            },
            //发布商品
            addGoods(){
                 this.$router.push({ path: '/layout/goods/manage_child'})
            },
            //搜索
            search(){
                if(this.searchkey==''){
                    this.$Message.error('请输入关键字')
                }else{
                    this.tableLoading = true
                    const url = `https://api.jiapuji.vip/gateway/admin/service/mail/commodity/get?type=4&page=${this.page}&size=${this.size}&name=${this.searchkey}`
                    axios({url:url}).then(res=>{
                        if(res.status==200 && res.data.code==1){
                            this.tableLoading = false
                            this.goodsList = res.data.data.list
                            this.total = res.data.data.total
                            console.log(res.data.data.list[0].commodityCode==null)
                        }else{
                            this.$Message.error({
                                background: true,
                                content: '加载失败，亲稍后再试'
                            });
                        }
                    })
                }
            },
            //页码切换
            pageChange(e){
                console.log(e)
                this.page =e 
                this.getGoodsList()
            }
        },
        mounted(){
           this.getGoodsList();
           this.getGoodsGroup()
           this.getGoodsCategory()
        }
    }
</script>  
<style scoped>
    .operating{
        line-height: 60px;
        background-color: #F7F7F7;
        display: flex;
        align-items: center;
        padding-left: 20px;
        margin-bottom: 20px;
    }
    .tabs-nav{
        display: flex;
        align-items: center;
        margin-bottom: 20px;
    }
    .table-name{
        display: flex;
        align-items: center;
    }
    .table-name img{
        width: 80px;
        height: 80px;
        margin: 10px;
    }
    .table-name span{
        margin-left: 5px;
        color: blue;
        cursor: pointer;
    }
    .pagination{
        text-align: right;
        margin-top: 20px;
        padding-bottom: 70px;
    }
    .goods-image{
         object-fit: contain;
    }
</style>
     